import {
  SEND_MAIL_FORGOT_PASSWORD_FETCH,
  SEND_MAIL_FORGOT_PASSWORD_SUCCESS,
  SEND_MAIL_FORGOT_PASSWORD_ERROR,
  SEND_MAIL_FORGOT_PASSWORD_RESET,
  ForgotPasswordState,
  ForgotPasswordActions,
  ForgotPasswordStatus,
  initialState,
  SEND_MAIL_FORGOT_PASSWORD_REPEATED_EMAIL,
} from './types'

const reducers = (state = initialState, action?: ForgotPasswordActions): ForgotPasswordState => {
  switch (action?.type) {
    case SEND_MAIL_FORGOT_PASSWORD_FETCH:
      return {
        ...state,
        status: ForgotPasswordStatus.Loading,
        email: action?.payload?.email,
      }
    case SEND_MAIL_FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        status: ForgotPasswordStatus.Success,
      }
    case SEND_MAIL_FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        status: ForgotPasswordStatus.Error,
      }
    case SEND_MAIL_FORGOT_PASSWORD_REPEATED_EMAIL:
      return {
        ...state,
        status: ForgotPasswordStatus.RepeatedEmail,
      }
    case SEND_MAIL_FORGOT_PASSWORD_RESET:
      return {
        ...state,
        status: ForgotPasswordStatus.Idle,
        email: undefined,
      }
    default:
      return state
  }
}

export default reducers
